import { Link } from "react-router-dom";
import { GoldButton } from "./GoldButton";
import { useRegistration } from "./RegistrationContext";
import { Badge } from "./Badge";

export const Header = () => {
  const { open } = useRegistration();
  return (
    <header className="relative z-40 border-b border-[rgba(232,184,74,0.18)] bg-[#0a0a0a]/85 backdrop-blur-md md:sticky md:top-0" data-testid="site-header">
      <div className="gutter flex h-[72px] flex-nowrap items-center justify-between gap-3">
        <Link to="/" className="flex min-w-0 items-center gap-2.5 sm:gap-3" data-testid="header-brand-link">
          <Badge size={48} />
          <span className="flex min-w-0 flex-col leading-none">
            <span className="font-display gold-text whitespace-nowrap text-[17px] tracking-[0.04em] sm:text-[22px]">EDUCATE II ELEVATE</span>
            <span className="font-mono-plex mt-1 text-[9.5px] tracking-[0.3em] text-[#a59f93]">BY J11</span>
          </span>
        </Link>
        <GoldButton size="sm" onClick={open} className="shrink-0" data-testid="header-save-seat-button">Save my seat</GoldButton>
      </div>
    </header>
  );
};
